import type { MutationSettings } from '@customTypes/index';
import { useMutation } from '@tanstack/react-query';

import type { UploadPhotoParams } from '@/shared/api/requests/photo/upload/request';
import { uploadPhoto } from '@/shared/api/requests/photo/upload/request';

export const useUploadPhotoMutation = (
  settings?: MutationSettings<UploadPhotoParams, typeof uploadPhoto>
) =>
  useMutation({
    mutationKey: ['uploadPhoto'],
    mutationFn: ({ params, config }) =>
      uploadPhoto({
        params,
        config
      }),
    ...settings?.options
  });
